import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function textSearchFilter(): ComponentStyle {
  return {
    componentName: 'textSearchFilter',
    variants: {
      fullWidth: {
        display: 'flex',
        flex: 1
      }
    }
  };
}
